import { createContext, useContext } from 'react';

// Carries every piece of duty-roster state, handlers and helpers from the
// DutyRoster container down to the header / grid / modal components. The
// container owns all the logic; the components are presentational and read
// what they need from here. This keeps behaviour identical to the original
// single-file component while splitting the JSX into manageable pieces.
const DutyRosterContext = createContext(null);

export const DutyRosterProvider = DutyRosterContext.Provider;
export const useDutyRoster = () => useContext(DutyRosterContext);

export default DutyRosterContext;
